import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './AdminContent.css';

const summaryCards = [
  { key: 'game_packs', label: 'Game Packs', to: '/admin/content/game-packs' },
  { key: 'game_modes', label: 'Game Modes', to: '/admin/content/game-modes' },
  { key: 'quest_packs', label: 'Quest Packs', to: '/admin/content/quest-packs' },
  { key: 'questions', label: 'Questions', to: '/admin/content/questions' },
  { key: 'hosts', label: 'Hosts', to: '/admin/content/hosts' },
];

const AdminContentHome = () => {
  const [state, setState] = useState({
    loading: true,
    error: '',
    summary: null,
  });

  useEffect(() => {
    const token = localStorage.getItem('auth_token');
    const controller = new AbortController();

    const loadSummary = async () => {
      try {
        const response = await fetch('/.netlify/functions/admin-get-content-summary', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          signal: controller.signal,
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) {
          throw new Error(data?.message || 'Unable to load content.');
        }
        setState({
          loading: false,
          error: '',
          summary: data.summary || null,
        });
      } catch (error) {
        if (controller.signal.aborted) {
          return;
        }
        setState({
          loading: false,
          error: error.message || 'Unable to load content.',
          summary: null,
        });
      }
    };

    loadSummary();

    return () => controller.abort();
  }, []);

  return (
    <section className="cq-admin-page">
      <header className="cq-admin-page__header">
        <div>
          <p className="cq-admin-page__eyebrow">Read-Only Content Library</p>
          <h2 className="cq-admin-page__title">Content</h2>
          <p className="cq-admin-page__copy">Inspect the current content graph without entering Creator Studio.</p>
        </div>
      </header>

      {state.loading ? <div className="cq-admin-empty-state"><p className="cq-admin-empty-state__title">Loading content...</p></div> : null}
      {!state.loading && state.error ? <div className="cq-admin-empty-state"><p className="cq-admin-empty-state__title">{state.error}</p></div> : null}

      {!state.loading && !state.error && state.summary ? (
        <>
          <div className="cq-admin-content-summary-grid">
            {summaryCards.map((card) => (
              <Link key={card.key} to={card.to} className="cq-admin-content-summary-card">
                <p className="cq-admin-content-summary-card__label">{card.label}</p>
                <p className="cq-admin-content-summary-card__value">{state.summary[card.key] ?? 0}</p>
              </Link>
            ))}
          </div>

          <div className="cq-admin-panel">
            <h3 className="cq-admin-section-title">Relationship Chain</h3>
            <p className="cq-admin-page__copy cq-admin-content-chain">
              Game Pack → Game Mode + Host → Tags → Quest Packs → Questions
            </p>
          </div>
        </>
      ) : null}
    </section>
  );
};

export default AdminContentHome;
